/**
 * Posizione - SPECIFICHE 2.2
 *
 * Posizione lavorativa per cassa e periodo. Storico completo.
 * Il flag `attuale = 1` indica la posizione corrente per quella cassa.
 */
import { z } from 'zod';
import { CassaCodeSchema, StatoLavoratoreSchema, str, dateStr } from './common.ts';

export const PosizioneSchema = z.object({
  id: z.number(),
  lavoratoreId: z.number(),
  cassa: CassaCodeSchema,
  periodo: z.string(), // YYYYMM
  attuale: z.number(), // 0 o 1
  impresaId: z.number().nullable(),
  dataAssunzione: dateStr,
  dataCessazione: dateStr,
  qualifica: str,
  stato: StatoLavoratoreSchema, // V, T, C, D
  codce: str, // Codice lavoratore presso la cassa
  codinps: str,
  numape: str,
  sindacato: str, // 10, 20, 30, ecc.
  dataSindacato: dateStr,
  // NULL = cassa mono-tipo (default); valore = codice tipo
  // (ISCRITTI/ALTRI/TUTTI/_ALLINEAMENTO). Vedi
  // `memory/casse-multi-tipo-solo-attivi/obiettivo.md`.
  tipoCaricamento: z.string().nullable(),
  createdAt: str,
});

export type Posizione = z.infer<typeof PosizioneSchema>;

// Per INSERT (senza id e timestamp). `tipoCaricamento` e' opzionale per
// backward-compat: i callsite mono-tipo possono ometterlo (default NULL).
export type PosizioneInsert =
  Omit<Posizione, 'id' | 'createdAt' | 'tipoCaricamento'>
  & { tipoCaricamento?: string | null };
